import { ZertifizierungEnergieverbraucher } from './ZertifizierungEnergieverbraucher';

export function processZertifizierung(data: any) {
    const jahr = data.last_year || new Date().getFullYear() - 1;
    const Energieverbraucher = new ZertifizierungEnergieverbraucher(data, jahr);
    data['zertifizierung'] = {
        energieverbraucher: Energieverbraucher.getData()
    };
}
